"use client";
import React, { useRef } from 'react';
import data from './data.json';
import { useDraggable } from "react-use-draggable-scroll";
import { Link } from 'react-router-dom';
import { InfiniteSlider } from '@/components/motion-primitives/infinite-slider';
import { ProgressiveBlur } from '@/components/motion-primitives/progressive-blur';
import { toast } from "sonner";

export default function RealProjectsThumb() {
    const ref = useRef();
    const { events } = useDraggable(ref);

    return (
        <div className='relative w-full h-[50vh]' {...events} ref={ref}>
            <InfiniteSlider gap={12} speedOnHover={1}>
                {data.realProjects.map((projectExp) => {
                    const isPlaceholder = projectExp.link === "/#";

                    const handleClick = (e) => {
                        e.preventDefault();
                        toast("Still writing...", {
                            description: `${projectExp.projectname} is not yet available.`,
                            duration: 3000,
                        });
                    };

                    return (
                        <div
                            key={projectExp.id}
                            className='flex flex-col gap-y-2 dark:grayscale hover:dark:grayscale-0 hover:scale-[1.02] transition-all duration-300 ease-in-out hover:saturate-200 darak:hover:saturate-100'
                        >
                            {isPlaceholder ? (
                                <div
                                    onClick={handleClick}
                                    className='cursor-pointer relative flex-shirk-0 w-auto justify-center overflow-y-hidden'
                                >
                                    <img
                                        src={projectExp.src}
                                        className='w-auto h-[40vh] border rounded-2xl'
                                    />
                                </div>
                            ) : (
                                <Link
                                    to={projectExp.link}
                                    className='relative flex-shirk-0 w-auto justify-center overflow-y-hidden'
                                >
                                    <img
                                        src={projectExp.src}
                                        className='w-auto h-[40vh] border rounded-2xl'
                                    />
                                </Link>
                            )}
                            <div className='flex justify-between'>
                                <p className='text-xs opacity-100 font-light'>
                                    {projectExp.projectname}
                                </p>
                                <p className='text-xs opacity-100 font-light capitalize'>
                                    {projectExp.status}
                                </p>
                            </div>
                        </div>
                    );
                })}
            </InfiniteSlider>

            <ProgressiveBlur
                className='pointer-events-none absolute top-0 left-0 h-full w-[80px]'
                direction='left'
                blurIntensity={1}
            />
            <ProgressiveBlur
                className='pointer-events-none absolute top-0 right-0 h-full w-[80px]'
                direction='right'
                blurIntensity={1}
            />
        </div>
    );
}
